<!-- 查看实训案例 -->
<template>
  <div class="el-trainingIndex" style="padding: 20px 20px 0;">
    <el-row class="content_block mb20">
      <TitleInfo title="查看实训案例" :titleImg="caozuo"></TitleInfo>
      <el-row class="p20">
        <el-row>
          <el-button :class="onIndex ==0?'check':''" plain @click="checkTask({},0)">案例介绍</el-button>
          <template v-for="(item ,index) in taskList">
            <el-button :class="onIndex ==(index + 1)?'check':''" plain @click="checkTask(item,index + 1)">任务{{index + 1}}</el-button>
          </template>
          <template v-if='examType == 2'>
            <span style="background-color: #EFF2F7;float: right;color: #2789E2;padding: 10px 30px;">合计得分：99分</span>
          </template>
        </el-row>
      </el-row>
      <template v-if="onIndex == 0">
        <el-row style="border: 1px solid #D3D3D3;margin: 0 20px 20px 20px;padding: 0 20px 20px 20px;min-height: calc(100vh - 280px);">
          <p class="fontB"><i class="el-icon-document-remove icon_"></i>案例名称：</p>
          <p>{{indexInfo.handsOnName}}</p>
          <p class="fontB"><i class="el-icon-document icon_"></i>案例介绍：</p>
          <el-row class="aljj">
            <el-row v-html="indexInfo.handsOnRecommend"></el-row>
          </el-row>
        </el-row>
      </template>
      <Task1 v-if="onTaskInfo.taskType == 1" :key="new Date().getTime()" :taskId="onTaskInfo.taskId" examType="examType"></Task1>
      <Task2 v-if="onTaskInfo.taskType == 2" :key="new Date().getTime()" :taskId="onTaskInfo.taskId" examType="examType"></Task2>
      <Task3 v-if="onTaskInfo.taskType == 3" :key="new Date().getTime()" :taskId="onTaskInfo.taskId" :courseId="teacherOpenCourseId" examType="examType"></Task3>
      <Task4 v-if="onTaskInfo.taskType == 4" :key="new Date().getTime()" :taskId="onTaskInfo.taskId" examType="examType"></Task4>
      <Task5 v-if="onTaskInfo.taskType == 5" :key="new Date().getTime()" :taskId="onTaskInfo.taskId" examType="examType"></Task5>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
import Task1 from "./components/PracticalTraining/Task1";	//任务1
import Task2 from "./components/PracticalTraining/Task2";	//任务2
import Task3 from "./components/PracticalTraining/Task3";	//任务3
import Task4 from "./components/PracticalTraining/Task4";	//任务4
import Task5 from "./components/PracticalTraining/Task5";	//任务5
export default {
  name: "TrainingIndex",
  components: {
  	TitleInfo,
  	Task1,
  	Task2,
  	Task3,
  	Task4,
  	Task5,
  },
  data() {
    return {
      caozuo:require("../../images/course/caozuo@2x.png"),
      onIndex:0,
      examType:this.$route.query.examType, //查看类型
      handsOnId:this.$route.query.handsOnId, //实训ID
      teacherOpenCourseId:this.$route.query.courseId, //课程ID
      indexInfo:{},
      taskList:[],
      onTaskInfo:{}, //当前选中的任务信息
    };
  },
  created() {
    this.getInfo();
    this.getTaskList();
  },
  mounted() {

  },
  methods: {
    getInfo(){
      this.$get("/api/teacherOpenCourseHandsOn/getInfo.do",{handsOnId:this.handsOnId}).then((ret) =>{
        if(ret.code == 0){
          this.indexInfo = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    startExam(item){
      this.$router.push({name:'CoachExam',query:{type:1}});
    },
    resultDetails(item){ //查看错题
      this.$router.push({name:'CoachExam',query:{type:2}});
    },
    checkTask(item,index){ //切换任务
      this.onIndex = index;
      this.onTaskInfo = item;
    },
    getTaskList(){ //任务List查看
      this.$post("/api/teacherOpenCourseHandsOnSimulationTasks/getPageList.do",{handsOnId:this.handsOnId}).then((ret) =>{
        if(ret.code == 0){
          this.taskList = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    }
  }
};
</script>
 <style  lang="less">
  .el-trainingIndex{
    // min-height: calc(100vh - 120px);
    .content_block{
      min-height: calc(100vh - 140px);
      background-color: #ffffff;
      .el-divider--horizontal{
        margin: 0;
      }
    }
    .icon_{
      color: #2789E2;margin-right: 10px;
    }
    .check{
      color: #2789E2;
      border-color:#2789E2 ;
    }
    .aljj{
      p{
        margin: 0;
        line-height: 30px;
        // text-indent: 2em;
      }
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/SeePracticeDetails.vue